import Course from '@/models/Course.js';
import Model from '@/models/Model.js';
import User from '@/models/User.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

export default class DiscussionThread extends Model {
    static entity = 'discussion_threads';

    static includes = ['replies'];

    static backend_class = 'App\\Models\\DiscussionThread';

    static queryBuilder() {
        return new QueryBuilder(this.entity).include(this.includes);
    }

    static fields() {
        return {
            id: this.attr(null),
            activity_id: this.attr(null),
            body: this.attr(null),
            course_id: this.attr(null),
            created_at: this.attr(null),
            deleted_at: this.attr(null),
            title: this.attr(null),
            updated_at: this.attr(null),
            user_id: this.attr(null),
            type: this.string('Discussion Thread'),
            read: this.attr(null),

            ...super.fields(),

            replies: this.attr(null),
            user: this.belongsTo(User, 'user_id'),
            course: this.belongsTo(Course, 'course_id'),
        };
    }

    static async fetch(endpoint = null) {
        const { response } = await this.api().get(endpoint, {
            persistBy: 'create',
        });

        return response.data;
    }
}
